<template>
  <div class="box-aside">
    <div :class="['logo', { 'logo1': $store.getters.aside_show }]" @click="logoTo">
      <img
        :src="$store.getters.aside_show ? $store.getters.material_data.logo_img : $store.getters.material_data.heng_logo_img"
        alt="">
    </div>
    <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="$store.getters.aside_show"
      router>
      <!-- <el-menu-item index="/Dashboard" :class="{ 'is_active': $store.getters.path_to === '/Dashboard' }">
        <i class="el-icon-menu"></i>
        <span slot="title">数据大屏</span>
      </el-menu-item> -->
      <el-menu-item index="/GroupPurchaseAccount"
        :class="{ 'is_active': $store.getters.path_to === '/GroupPurchaseAccount' }">
        <i class="el-icon-document"></i>
        <span slot="title">商户列表</span>
      </el-menu-item>
      <el-menu-item index="/OrderList" :class="{ 'is_active': $store.getters.path_to === '/OrderList' }"
        v-if="$store.getters.identity !== 'customer'">
        <i class="el-icon-s-operation"></i>
        <span slot="title">订单列表</span>
      </el-menu-item>
      <el-menu-item index="/AgentList"
        v-if="$store.getters.identity === 'senior_agent' || $store.getters.identity === 'senior_oem_agent'"
        :class="{ 'is_active': $store.getters.path_to === '/AgentList' }">
        <i class="el-icon-document"></i>
        <span slot="title">代理商列表</span>
      </el-menu-item>
      <!-- <el-menu-item index="/BroadcastMerchant" :class="{ 'is_active': $store.getters.path_to === '/BroadcastMerchant' }">
        <i class="el-icon-setting"></i>
        <span slot="title">代播商户</span>
      </el-menu-item> -->
      <el-menu-item index="/MaterialManagement" :class="{ 'is_active': $store.getters.path_to === '/MaterialManagement' }"
        v-if="$store.getters.identity !== 'senior_agent' && $store.getters.identity !== 'senior_oem_agent'">
        <i class="el-icon-menu"></i>
        <span slot="title">素材管理</span>
      </el-menu-item>
      <!-- <el-menu-item index="/DataOverview" :class="{ 'is_active': $store.getters.path_to === '/DataOverview' }">
        <i class="el-icon-document"></i>
        <span slot="title">数据概览</span>
      </el-menu-item> -->
      <!-- <el-menu-item index="/IntelligentCustomerService"
        :class="{ 'is_active': $store.getters.path_to === '/IntelligentCustomerService' }">
        <i class="el-icon-setting"></i>
        <span slot="title">智能客服</span>
      </el-menu-item> -->
      <el-menu-item index="/LiveRecord" :class="{ 'is_active': $store.getters.path_to === '/LiveRecord' }">
        <i class="el-icon-document"></i>
        <span slot="title">直播记录</span>
      </el-menu-item>
      <el-menu-item index="/FinancialJournal" :class="{ 'is_active': $store.getters.path_to === '/FinancialJournal' }"
        v-if="$store.getters.identity !== 'customer' && ($store.getters.user_info ? $store.getters.user_info.agent.parent_id === 0 : false)">
        <i class="el-icon-c-scale-to-original"></i>
        <span slot="title">财务日志</span>
      </el-menu-item>
      <!-- <el-menu-item index="/PersonalSetting" :class="{ 'is_active': $store.getters.path_to === '/PersonalSetting' }">
        <i class="el-icon-setting"></i>
        <span slot="title">个人设置</span>
      </el-menu-item> -->
      <!-- <el-menu-item index="/HeyAssistant" :class="{ 'is_active': $store.getters.path_to === '/HeyAssistant' }">
        <i class="el-icon-chat-dot-round"></i>
        <span slot="title">云伴精灵</span>
      </el-menu-item> -->
      <!-- <el-submenu index="系统配置">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span slot="title">系统配置</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="LogManagement"
            :class="{ 'is_active': $store.getters.path_to === '/LogManagement' }">日志管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "CommonAside",
  data() {
    return {
      isCollapse: true,
    };
  },
  watch: {
  },
  created() {
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    // logo跳转
    logoTo() {
      this.$router.push(this.$store.getters.path)
    },
  }
}
</script>

<style lang="scss" scoped>
.box-aside {
  .logo {
    height: 40px;
    width: auto;
    font-size: 0;
    padding: 2.5px 10px;
    text-align: center;
    margin: 0 auto;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .logo1 {
    // height: 40px;
    width: 40px;
    // font-size: 0;
    padding: 2.5px 0;
    // text-align: center;
    // margin: 0 auto;

    // img {
    // height: 100%;
    // width: 100%;
    // }
  }

  ::v-deep .el-menu-vertical-demo {
    .el-menu-item {
      color: #3b3d3f;

      i {
        color: #3b3d3f;
      }
    }

    .is_active {
      color: #409EFF !important;

      i {
        color: #409EFF !important;
      }
    }

    .el-submenu {
      .el-menu--inline {
        .el-menu-item-group {
          ul {
            .el-menu-item {
              color: #3b3d3f;
            }

            .is_active {
              color: #409EFF !important;
            }
          }
        }
      }
    }
  }
}
</style>